<template>
  <!--
      作者 gmshop
      时间：2012-12-5
      描述：设置-设置
  -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">{{getAppinfo('balance_text')}}释放设置</div>
      <el-form-item :label="'是否开启'+getAppinfo('balance_text')+'释放：'">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
        <div>比例更改不会影响原来记录的释放速度</div>
        <div>当冻结额度为0时，才会采用新的积分释放设置</div>
        <div>只有用户收货后，才会开始{{getAppinfo('balance_text')}}释放</div>
      </el-form-item>
      <el-form-item label="释放时间">
       <div>

          <div v-for="(item,index) in form.stime" :key="index"
         
          style="border-radius: 10px;  float: left; margin-left: 10px;margin-top: 10px;width: 60px;height: 30px;line-height: 30px;text-align: center;line-height: 30px;"
          :style="{'background':item.flag?'#409EFF':'#F5F7FA','color':item.flag?'#fff':''}"
          @click="stime_click(index)"
          >{{ item.name }}</div>
          <div style="clear: both;"></div>
       </div>
      </el-form-item>
      <el-form-item label="释放类型：">
      <el-radio-group  v-model="form.type">
          <el-radio :label="0">固定</el-radio>
          <el-radio :label="1">比例</el-radio>
        </el-radio-group>
        </el-form-item>
      <el-form-item label="初始释放速度：" prop="initial_rate" >
        <el-input v-model="form.initial_rate" type="number" :min="0" :max="100" :step="1" placeholder="请输入数额" class="max-w460">
          <template slot="append" v-if="form.type == 0" >个</template>
          <template slot="append" v-if="form.type == 1" >%</template>
        </el-input>
        <div>
          总额：1000，每天释放
          <span v-if="form.type == 0">{{ form.initial_rate }}</span>
          <span v-if="form.type == 1">{{  getPrice((form.initial_rate/100 ) * 1000 )}}</span>
          <span>个</span>
        </div>
      </el-form-item>

      <el-form-item label="直推奖励：">
      <el-radio-group  v-model="form.ztype">
          <el-radio :label="0">固定</el-radio>
          <el-radio :label="1">比例</el-radio>
        </el-radio-group>

        </el-form-item>


        <el-form-item label="直推奖励：">
          <el-input v-model="form.zpoint" type="number" :min="0" :max="100" :step="1"
           placeholder="请输入数额" class="max-w460">
            <template slot="append" v-if="form.ztype == 0" >个</template>
            <template slot="append" v-if="form.ztype == 1" >%</template>
          </el-input>
          <div>如固定{{form.zpoint}}，直推A消费1000，自己奖励{{form.zpoint}}元</div>
          <div>如比例{{form.zpoint}}%，直推A消费1000，自己奖励{{getPrice((form.zpoint/100 ) * 1000 )}}元</div>
        </el-form-item>



    <div style="clear: both; height: 100px;width: 100rpx;"></div>


      <!-- region_agent -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import PointsreleaseApi from '@/api/pointsrelease.js';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{},
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,
          initial_rate: 0,
          type:0,
          ztype:0,
          zpoint:0,
          stime:[{
            id:1,
            name:"周一",
            flag:false,
          },{
            id:2,
            name:"周二",
            flag:false,
          },{
            id:3,
            name:"周三",
            flag:false,
          },{
            id:4,
            name:"周四",
            flag:false,
          },{
            id:5,
            name:"周五",
            flag:false,
          },{
            id:6,
            name:"周六",
            flag:false,
          },{
            id:7,
            name:"周日",
            flag:false,
          }]
        },
      };
    },
    created() {
      this.getParams()
    },

    methods: {
      roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        console.log("price",this.roundToDecimalPlace(price,2))
        return this.roundToDecimalPlace(price,2)
      },
      stime_click(index){
        var stime =  this.form.stime;
        stime[index].flag = !stime[index].flag;
        this.form.is_open = this.form.is_open 
        this.$set(this.form, 'stime', stime)
        this.$forceUpdate()
      },

      /*获取配置数据*/
      getParams() {
        let self = this;
        PointsreleaseApi.getSetting({}, true)
          .then(res => {
            self.form = res.data.setting;
            if(!self.form.type){
              self.form.type = 0;
            }
            if(!self.form.ztype){
              self.form.ztype = 0;
            }
            if(!self.form.stime){
              console.log("self.form.stime",self.form.stime);
              self.form.stime = [{
                          id:1,
                          name:"周一",
                          flag:false,
                        },{
                          id:2,
                          name:"周二",
                          flag:false,
                        },{
                          id:3,
                          name:"周三",
                          flag:false,
                        },{
                          id:4,
                          name:"周四",
                          flag:false,
                        },{
                          id:5,
                          name:"周五",
                          flag:false,
                        },{
                          id:6,
                          name:"周六",
                          flag:false,
                        },{
                          id:7,
                          name:"周日",
                          flag:false,
                        }]
            }
            console.log(self.form.stime)
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },

      /*转JSON字符串*/
      convertJson(list) {
        let obj = {};

        list.forEach(item => {
          obj[item.grade_id] = item.award;
        });

        return JSON.stringify(obj);
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        // params.award_detail = self.convertJson(self.grade_list);
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PointsreleaseApi.saveSetting(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/pointsrelease/setting/index.vue